import React from "react";
import tw from "twin.macro";
import PostCard from "./PostCard";
import { HighlightedText } from "./ui";

/** « À lire aussi » : articles liés en fin d'article. */

const Section = tw.section`mt-20`;
const Heading = tw.h2`text-2xl sm:text-3xl font-black text-gray-900 tracking-wide`;
const Grid = tw.div`mt-8 grid gap-8 md:grid-cols-2 lg:grid-cols-3`;

export default function RelatedPosts({ posts, heading }) {
  if (!posts || !posts.length) return null;
  return (
    <Section aria-labelledby="related-heading">
      <Heading id="related-heading">
        {heading || (
          <>
            À lire <HighlightedText>aussi.</HighlightedText>
          </>
        )}
      </Heading>
      <Grid>
        {posts.map(post => (
          <PostCard key={post.slug} post={post} />
        ))}
      </Grid>
    </Section>
  );
}
